export const TIMEOUT_MESSAGE = 'TIMEOUT';
export const HISTORY_GROUPING_LABEL_TYPE_NAME = 'grouping';

export type TTenantConfig = {
    tenantKey: string;
    ui?: string;
    groups: string[];
};

export type TTokenData = {
    exp?: number;
    iat?: number;
    name?: string;
    preferred_username?: string;
    scp?: string;
    aud?: string;
    groups?: string[];
    _claim_names?: {
        groups: string;
    };
    _claim_sources?: {
        src1: {
            endpoint: string;
        };
    };
};

export enum TErrorType {
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    HINT = 'HINT',
  SUCCESS = 'SUCCESS',
}

export type TUserData = {
    preferred_username: string;
    name: string;
    avatarUrl?: string;
    prename?: string;
    surname?: string;
    tenant?: string;
    tokenData?: TTokenData;
    token: string | null;
    tenantConfig?: TTenantConfig;
};

export type TUiConfig = {
    template: React.ComponentType<object>;
    routeConfig: TRouteConfig[];
};

export type TRouteConfig = {
    index: boolean;
    labelLangId: string;
    showInNavigation: boolean;
    routePath: string;
    apiPath: string;
    apiTenantKey: string;
    page: React.ComponentType<object>;
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    apiClient: any;
};

export type TThreadLabelType = string;

export const THREAD_DEFAULT_LANGUAGE_MODEL = 1;

export type TThread = {
    thread_id: string | null;
    thread_subject: string;
    language_model: number;
    type?: TThreadLabelType;
    created: string;
    updated: string;
    new?: boolean;
};

export type TMessageProperties = {
    rag_type?: 'adaptive' | 'naive';
};

export type TMessage = {
    thread_id?: string | null;
    message_id?: string | null;
    user_message: string;
    ai_message?: string | null;
    language_model?: number;
    references?: TMessageReference[];
    rag_type?: 'adaptive' | 'naive';
    properties?: TMessageProperties | null;
    created?: string;
    updated?: string;
    is_deep_research?: boolean;
    ai_assistant?: string;

    system_prompt?: string;
    document_repositories?: TDocumentRepository[];
    ai_model?: TAiModel;

    // TODO: check why this id returned from FastAPI
    // id: string | null;
    // role: 'user' | 'assistant';
    // content: string | null;
    // created_at: string | null;
};

export type TMessageReference = {
    name: string;
    file: string;
    page: number;
    /** Absolute source url from the backend, kept separate from `file` which may be a path only. */
    sourceUrl?: string;
    similarity_score?: number;
};

export type TMessageResponse = {
    thread_id?: string;
    messages: TMessage[];
};

export type TTemporaryFile = {
    temp_url: string;
};


export enum EFeedbackValue {
  DOWN = -1,
  UP = 1,
  NONE = 0,
}

export type TFeedback = {
  thread_id: string | null;           
  message_id: string | null;            
  feedback?: EFeedbackValue;      
  feedback_message?: string;     
};

export type TMimetype = {
  mimetype_id: string;
  mimetype: string;
  extension: string;
}

export type TDocumentRepository = {
  document_id: string;
  source_type: string;
  url: string;
  source_name: string;
  update_frequency: number;
  last_update?: Date;
  filters: TMimetype[];
  status?: string;
  search?: string;
  id?: string;
  folder_paths?: string[];
};

export type TUserRole = {
  id: string;
  name: string;
};

/** `selected` is the effective state: explicitly stored OR inherited from a selected parent. */
export type TSharePointFolderItem = {
  path: string;
  selected: boolean;
};

/** Response of `GET /{tenantKey}/sharepoint/folders?url=...` */
export type TSharePointFoldersResponse = {
  url: string;
  folders: string[];
  selection: {
    stored: string[];
    missing: string[];
    items: TSharePointFolderItem[];
  };
};

export type TSharePointFolderNode = {
  path: string;
  name: string;
  children: TSharePointFolderNode[];
};

export type TAiAgent = {
  id: string;
  name: string;
  descriptive_name: string;
  publish_url?: string;
  status: string;
  create_date: Date;
  last_update: Date;
  last_update_by: string;
  unique_user_count?: number;
  has_source_warning?: boolean;
  source_warning_indicator?: string;
  source_warning_message?: string | null;
  source_issue_fingerprint?: string | null;
  source_warning_acknowledged_at?: string | null;
  search?: string;
};

export type TAiAgentDetails = TAiAgent & {
  document_repositories: TDocumentRepository[];
  user_roles: TUserRole[];
  ai_model: TAiModel;
  ai_functions: TAiFunction[];
  system_prompt: string;
  prompts: string[];
  deepResearchEnabled?: boolean;
};

export type TAiModel = {
  id: string;
  name: string;
  temperature?: number;
};

export type TAiFunction = {
  id: string;
  name: string;
  description?: string;
};
